import { render, staticRenderFns } from "./yetkigrup.vue?vue&type=template&id=36f3d7f7&"
import script from "./yetkigrup.vue?vue&type=script&lang=js&"
export * from "./yetkigrup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports